import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { ApplicationService } from "app/services/application.service";
import { CarrierService } from "app/services/carrier.service";
import { UtilityServiceService } from "app/services/utility-service.service";
import { WorkflowService } from "app/services/workflow.service";
import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";
import { FilterService } from "app/shared/filter/filter.service";
import { Chart, ChartConfiguration, ChartItem, registerables,ChartOptions } from "chart.js";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { ModalDirective } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { resourceLimits } from "worker_threads";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {
  public modalRef: BsModalRef;
  @ViewChild("childModal", { static: true }) childModal: ModalDirective;

  isLoading: Boolean = false;

  activities: any = [];
  message: string = "Loading activities, please wait...";
  statuses: any = [];
  keyword: any = {};
  currentPage = 1;
  isEmpty: boolean = false;
  pageSize: number = 50;
  count: number = 0;
  disabled = false;
  ShowFilter = false;
  limitSelection = false;
  dropdownSettings: any = {};
  carrierNumber: string;
  carrierName: string;
  processFlag: boolean = false;
  currentUserName: string = "";
  userData: any = environment.authWebApi.userData;
  workflow_role: number;
  workflow_user: string;
  selectedcarrier: any = null;
  selectedIndex: number;

  companyRegNumber: string;
  first_Name: string;
  surname: string;
  id_number: string;
  ApplicationNumber: string;
  ApplicationType: string;
  Status: string;
  DateAssigned: Date;

  selectedUser: string = "";
  roleUsers: any = [];

  bar_labels: any = [];
  bar_values: any = [];
  dynamic_bar_data: any = {};
  status_bar_labels: any = [];
  status_bar_values: any = [];
  status_bar_data: any = {};
  app_pie_labels: any = [];
  app_pie_values: any = [];
  app_pie_data: any = {};
  bar_data: any = {};
  card_data: any = {};
  carddata_yesterday: any = {};
  carddata_last7days: any = {};
  carddata_thismonth: any = {};
  filterby: string = 'Today';
  piedata_byapp: any = {};
  bardata_bystatus: any = [];

  user_data = { CountAssigned: 0, TimeTaken: 0 };
  role_id: number;
  activity_id: number;
  assigneduser: string;
  assignedusername: string;
  activity_status: string;

  filtergrid: boolean = false;
  filteruser: any = '';

  application_id: any;
  applicant_name: any;
  application_type: any;

  readmore:boolean = false;

  constructor(
    private service: WorkflowService,
    private carrierService: CarrierService,
    private applicationService: ApplicationService,
    private router: Router,
    private toater: ToastNotificationService,
    private filter: FilterService,
    public utility: UtilityServiceService
  ) {}

  ngOnInit(): void {
    this.workflow_role = this.userData.Roles.find(
      (p) => p.IsWorkflowRole == true
    ).Id;
    this.workflow_user = this.userData.User.UserName;

    this.loadActivities(this.currentPage, this.pageSize);
  }

  //#region MainData
  loadActivities(page: number = 1, pageSize: number = 50) {
    this.isLoading = true;
    this.service.getAllActivity(page, pageSize).subscribe(
      async (result: any) => {
        this.activities = await this.matchApplications(result);
      },
      (error) => {
        this.toater.error(
          "Failed to load user activity. Please try again",
          "Activity"
        );
        this.isLoading = false;
      }
    );
  }

  matchApplications(results): Observable<any> {
    var listactivities: any = [];
    results.data.forEach((item) => {
        var obj = {
          id: item.id,
          applicationId: item.applicationId,
          activityid: item.activityId,
          applicationType: item.applicationType,
          activityStatus: item.activityStatus,
          dateassigned: item.dateassigned,
          userassigned: item.userAssigned,
          userassignedname: item.userAssignedName,
          roleassignedid: item.roleAssignedId,
          applicant: item.applicant,
        };

        listactivities.push(obj);
    });
    this.onLoadDashboardData();
    return listactivities;
  }

  onLoadDashboardData() {
    this.bar_labels = [];
    this.bar_values = [];

    this.service.getDashboardData().subscribe(
      async (result: any) => {
        this.card_data = result.Card;
        this.carddata_yesterday = result.CardYesterday;
        this.carddata_last7days = result.Card7Days;
        this.carddata_thismonth = result.CardThisMonth;
        this.bar_data = result.Bar;
        this.piedata_byapp = result.PieByApp
        this.bardata_bystatus = result.BarByStatus

        for (let key in this.bar_data) {
          this.bar_labels.push(key);
          this.bar_values.push(this.bar_data[key]);
        }

        this.dynamic_bar_data = {
          labels: this.bar_labels,
          datasets: [
            {
              indexAxis: 'y',
              label: "No of Applications Per User",
              backgroundColor: "#274C9C",
              borderColor: "#274C9C",
              data: this.bar_values,
            },
          ],
        };

        this.bardata_bystatus.forEach(element => {
          this.status_bar_labels.push(element.status);
          this.status_bar_values.push(element.count);
        });

        this.status_bar_data = {
          labels: this.status_bar_labels,
          datasets: [
            {
              label: "No of Applications Per Status",
              backgroundColor: "#274C9C",
              borderColor: "#274C9C",
              data: this.status_bar_values,
            },
          ],
        };

        this.piedata_byapp.forEach(element => {
          this.app_pie_labels.push(element.type);
          this.app_pie_values.push(element.count);
        });

        this.app_pie_data = {
          labels: this.app_pie_labels,
          datasets: [
            {
              label: "No of Activity By App",
              backgroundColor: ["#d3dbeb","#274C9C","#7d93c3","#526faf","#a8b7d7"],
              data: this.app_pie_values,
            },
          ],
        };
        //#region Reset Charts

        let chartStatus = Chart.getChart("my-chart"); // <canvas> id
        let appsPieChart = Chart.getChart("piebyapp-chart"); // <canvas> id
        let statusBarChart = Chart.getChart("barbystatus-chart"); // <canvas> id

        if (chartStatus != undefined) {
          chartStatus.destroy();
        }

        if (appsPieChart != undefined) {
          appsPieChart.destroy();
        }

        if (statusBarChart != undefined) {
          statusBarChart.destroy();
        }

        this.createChart();
        this.createAppPieChart();
        this.createStatusBarChart();
        //#endregion
      },
      (error) => {
        this.toater.error(
          "Failed to load user activity. Please try again",
          "Activity"
        );
        this.isLoading = false;
      }
    );
  }

  createChart(): void {
    const that = this;
    Chart.register(...registerables);
    Chart.register(ChartDataLabels)


    let chartStatus = Chart.getChart("my-chart"); // <canvas> id
    console.log(chartStatus)
    if (chartStatus != undefined) {
      chartStatus.destroy();
    }

    const options = {
      onClick: function(e, item) {
        let datasetIndex = item[0].datasetIndex;
        let dataIndex = item[0].index;
        let datasetLabel = e.chart.data.datasets[datasetIndex].label;
        let value = e.chart.data.datasets[datasetIndex].data[dataIndex];
        let label = e.chart.data.labels[dataIndex];
        
        that.filtergrid = true;
        that.filteruser = label;
        that.filterActivities();       
     },
     title: {
      display: true,
      text: 'Applications Per User'
    },
     ticks: {
      precision: 0
  },
      responsive: true,
      maintainAspectRatio: false,
    };

    const config: ChartConfiguration = {
      type: "bar",
      data: this.dynamic_bar_data,
      options: options,
    };

    const chartItem: ChartItem = document.getElementById(
      "my-chart"
    ) as ChartItem;

    this.isLoading = false;

    new Chart(chartItem, config);
  }

  createAppPieChart(): void {
    Chart.register(...registerables);
    Chart.register(ChartDataLabels);


    let chartStatus = Chart.getChart('piebyapp-chart');

    if (chartStatus != undefined) {
      chartStatus.destroy();
    }

    const config: ChartConfiguration = {
      type: 'pie',
      data: this.app_pie_data,
      options: {
        responsive: true,
        plugins: {
          title: {
            display: true,
            text: 'Applications By Type'
          },
          legend: {
            position: 'bottom',
          },
          datalabels: {
            color: '#ffffff',
            font: {
              weight: 'bold',
              size: 16,
            }
          }
        }
    },
    };

    const chartItem: ChartItem = document.getElementById(
      'piebyapp-chart'
    ) as ChartItem;
    new Chart(chartItem, config);
  }

  createStatusBarChart(): void {
    const that = this;
    Chart.register(...registerables);
    Chart.register(ChartDataLabels)

    let statusBarChart = Chart.getChart("barbystatus-chart"); // <canvas> id
    if (statusBarChart != undefined) {
      statusBarChart.destroy();
    }

    const options: ChartOptions = {
      scales: {
        y: {
          ticks: {
            precision: 0,
          },
          grace: 1
        }
      },
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        title: {
          display: true,
          text: 'Applications By Status'
        },
        legend: {
          position: "bottom"
        },
        datalabels: {
          display: true,
          align: 'end',
          anchor: 'end',
          formatter: function(value, context) {
            return value > 0 ? value : null;
          },
          font: {
            weight: 'bold'
          },
        }
      },
    };

    const config: ChartConfiguration = {
      type: "bar",
      data: this.status_bar_data,
      options: options,
    };

    const chartItem: ChartItem = document.getElementById(
      "barbystatus-chart"
    ) as ChartItem;

    this.isLoading = false;

    new Chart(chartItem, config);
  }

  filterChange(event){
    this.filterby = event.target.value;
  }

  resetGridData(){
    this.filtergrid = false;
    this.filterActivities();
  }

  filterActivities(page: number = 1, pageSize: number = 50){
    this.isLoading = true;
    this.service.getAllActivity(page, pageSize).subscribe(
      async (result: any) => {
        this.activities = await this.matchFilteredData(result);
      },
      (error) => {
        this.toater.error(
          "Failed to load user activity. Please try again",
          "Activity"
        );
        this.isLoading = false;
      }
    );
  }

  matchFilteredData(results): Observable<any> {
    var listactivities: any = [];
    results.data.forEach((item) => {
      if(this.filtergrid){
        if(item.userAssignedName == this.filteruser){
          var obj = {
            id: item.id,
            applicationId: item.applicationId,
            activityid: item.activityId,
            applicationType: item.applicationType,
            activityStatus: item.activityStatus,
            dateassigned: item.dateassigned,
            userassigned: item.userAssigned,
            userassignedname: item.userAssignedName,
            roleassignedid: item.roleAssignedId,
            applicant: item.applicant,
          };
  
          listactivities.push(obj);
        }
      }else{
        var obj = {
          id: item.id,
          applicationId: item.applicationId,
          activityid: item.activityId,
          applicationType: item.applicationType,
          activityStatus: item.activityStatus,
          dateassigned: item.dateassigned,
          userassigned: item.userAssigned,
          userassignedname: item.userAssignedName,
          roleassignedid: item.roleAssignedId,
          applicant: item.applicant,
        };

        listactivities.push(obj);
      }        
    });

    this.isLoading = false;
    return listactivities;
  }

  onView(item) {
    this.isLoading = true;
    this.role_id = item.roleassignedid;
    this.activity_id = item.activityid;
    this.assigneduser = item.userassigned;
    this.assignedusername = item.userassignedname;
    this.activity_status = item.activityStatus;
    this.loadRoleUsers(item.roleassignedid);
    this.onLoadUserData();
    this.onWorkflowTracking(item)
  }

  //#endregion

  onWorkflowTracking(item){
    this.application_id = item.applicationId;
    this.applicant_name = item.applicant;
    this.application_type = item.applicationType;

    this.getTimeline(item.applicationId);
  }

  async getTimeline(foreignkeyid){
    this.isLoading = true;
    await this.service.getWorkflowTimeline(foreignkeyid).subscribe(
      (result) => {
        console.log(result)
        this.activities = result;
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  onReadMore(){
    this.readmore = !this.readmore;
  }

  //#region PoupData
  loadRoleUsers(roleid) {
    this.isLoading = true;
    this.service.getRoleUsers(roleid).subscribe(
      async (result: any) => {
        this.setRoleUsers(result);
        this.childModal.show();
        this.isLoading = false;
      },
      (error) => {
        this.toater.error(
          "Failed to load user activity. Please try again",
          "Activity"
        );
        this.isLoading = false;
      }
    );
  }

  onLoadUserData() {
    this.service.getUserData(this.assigneduser, this.activity_id).subscribe(
      async (result: any) => {
        this.user_data = result;
        this.setAssignedActivityPerUser()
        
        this.isLoading = false;
      },
      (error) => {
        this.toater.error(
          "Failed to load user activity. Please try again",
          "Activity"
        );
        this.isLoading = false;
      }
    );
  }

  setRoleUsers(data){
    data.forEach((user:any) => {
    console.log(user.UnavailableYN)

      if(user.UnavailableYN=='true'){
        user.displayName =  user.displayName + " *Away*";
      }

      if(this.bar_data[user.displayName]){
        user.displayName = user.displayName + " (" + this.bar_data[user.displayName] + ")";
      }else{
        user.displayName = user.displayName + " (0)";
      }
    });
    this.roleUsers = data
  }
  setAssignedActivityPerUser(){
    this.roleUsers = this.roleUsers.filter(
      (p) => p.userName != this.assigneduser
    );

    this.roleUsers.forEach((user:any) => {
      console.log(user);
      console.log(this.bar_data)
    });
  }

  onProceed() {
    this.isLoading = true;
    this.service
      .reassignActivity(this.activity_id, this.selectedUser)
      .subscribe(
        async (result: any) => {
          this.childModal.hide();
          this.loadActivities();
          this.toater.success("Task successfully reassigned", "Reassign");
        },
        (error) => {
          this.toater.error(
            "Failed to load user activity. Please try again",
            "Activity"
          );
          this.isLoading = false;
        }
      );
  }

  onCancel() {
    this.childModal.hide();
    this.loadActivities();
  }

  //#endregion

  onSearch() {}

  onReset() {}
}
